export default {"src":"/_next/static/media/solana_logo.6941c1ac.svg","height":409,"width":2190,"blurWidth":0,"blurHeight":0};